import { useMutation } from '@apollo/client/react';
import { getCurrentUserId } from '@guuru/auth-web';
import SEND_CHAT_MESSAGE from './mutations/SendChatMessage';

interface UseChatMessagesSenderProps {
  chatId: string;
  isUser?: boolean;
}

interface TextInput {
  text: string;
  type?: 'text';
}

interface AttachmentInput {
  type: 'attachment';
  address?: string;
  filename: string;
  mimetype: string;
}

type PostingInput = TextInput | AttachmentInput;

export default ({ chatId, isUser = false }: UseChatMessagesSenderProps) => {
  const [createNewMessage] = useMutation(SEND_CHAT_MESSAGE);

  const createMessage = async (posting: PostingInput) => {
    const uid = await getCurrentUserId();

    await createNewMessage({
      variables: {
        input: {
          userId: uid,
          chatId,
          isUser,
          isBot: false,
          posting: {
            ...posting,
            author: uid,
            isUser,
            isBot: false,
            hideForUser: false,
            hideForExpert: false,
            data: null,
          },
        },
      },
    });
  };

  const sendMessage = ({ text, type = 'text' }: TextInput) =>
    createMessage({ text, type });

  const sendAttachment = (
    readUrl: string,
    filename: string,
    mimetype: string,
  ) => {
    createMessage({
      address: readUrl,
      filename,
      mimetype,
      type: 'attachment',
    });
  };

  return { sendMessage, sendAttachment };
};
